import { AuthContext } from "@/contexts";
import { Button, InputGroup, useToast } from "@chakra-ui/react";
import { FormEvent, useContext, useState } from "react";
import { CustomInput as InputForm } from "@/components/Input";

import {
  Flex,
  Input,
  Link,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  Text,
  Img,
  useBoolean
} from "@chakra-ui/react";
import router from "next/router";

export function LoginModal({ EmailID, PassID }) {
  const { signIn } = useContext(AuthContext);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [ShowPassword, setShow] = useBoolean();
  const toast = useToast();
  async function handleLogin(event: FormEvent) {
    event.preventDefault();
    signIn({ UserEmail: email, password }).then(({ status, message }) => {
      toast.closeAll();
      if (status) {
        toast({
          title: "Login realizado com sucesso.",
          status: "success",
          position: "bottom",
          duration: 5000,
          isClosable: true,
          containerStyle: {
            color: "white",
            fontFamily: "arial",
            fontWeight: "100"
          }
        });
      } else {
        toast({
          title: message,
          status: "error",
          position: "bottom",
          duration: 5000,
          isClosable: true,
          containerStyle: {
            color: "white",
            fontFamily: "arial",
            fontWeight: "100"
          }
        });
      }
    });
  }

  return (
    <PopoverContent textStyle="Regular" boxShadow="0 0 10px #666" bgColor="white">
      <PopoverArrow />
      <PopoverBody w="310px" h="350px" mx="auto">
        <Flex
          direction="column"
          p="15px"
          justifyContent="space-evenly"
          alignItems="center"
          h="100%"
        >
          <Text color={"black"} textStyle="titleSpaced" fontSize="text3" mb="10px">
            ACESSAR CONTA
          </Text>
          <Flex as="form" onSubmit={handleLogin} direction="column" w="full" mx="auto">
            <Input
              value={email}
              name={"email"}
              fontSize={"16px"}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              height={"40px"}
              border="1px solid"
              borderRadius="5px"
              borderColor="#A9A9A9"
              placeholder="E-mail"
              color="gray.900"
              mb="10px"
              width="full"
              _focus={{ borderColor: "black", boxShadow: "none" }}
            />
            <InputGroup
              display="flex"
              alignItems="center"
              border="1px solid"
              borderColor="#A9A9A9"
              borderRadius={"5px"}
              fontSize={"14px"}
              _focus={{ borderColor: "green", boxShadow: "none" }}
            >
              <Input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={ShowPassword ? "text" : "password"}
                name={"password"}
                height={"40px"}
                borderRadius="5px"
                borderColor="white"
                placeholder="Senha"
                width="full"
                color="gray.900"
                _focus={{ borderColor: "white", boxShadow: "none" }}
              />
              <Link mx={["10px", "10px"]}>
                <Img
                  w={["30px", "30px"]}
                  alt={"Alternative to Image"}
                  src={
                    ShowPassword
                      ? "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/password-hidden.svg"
                      : "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/password-nohidden.svg"
                  }
                  onClick={setShow.toggle}
                  _focus={{ border: "none" }}
                />
              </Link>
            </InputGroup>
            <Link
              fontSize="text4"
              color="#58585A"
              alignItems="right"
              mb="10px"
              mt="5px"
              ml={"10px"}
              textStyle="Bold"
              href="/recuperar-senha/enviar-email"
            >
              Esqueceu a senha?
            </Link>
            <Button
              bgColor="#128A15"
              color={"white"}
              borderRadius="5px"
              textStyle={"Regular"}
              type="submit"
              width="full"
              _hover={{ opacity: "80%" }}
            >
              ACESSAR CONTA
            </Button>
          </Flex>
          <Flex direction="column" w="full" mx="auto">
            <Button
              bgColor="#121212"
              color={"white"}
              borderRadius="5px"
              textStyle={"Regular"}
              _hover={{ bg: "#FF003A" }}
              width="full"
              onClick={() => {
                router.push("/cadastro");
              }}
            >
              CRIAR CONTA
            </Button>
          </Flex>
        </Flex>
      </PopoverBody>
    </PopoverContent>
  );
}
